import React, { FC, useState } from 'react';
import { IconButton, TextField } from '@mui/material';
import { TranslationEditModal } from './TranslationEditModal';
import { TranslateIcon } from '../../../assets/icons/Icons';
import { theme } from '../../../theme';

interface TranslatableUrlProps {
    label: string;
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    urlError: string;
    entityType: string;
    entityId: string;
    property: string;
    nestedId?: string[];
}

const TranslatableUrl: FC<TranslatableUrlProps> = ({
    label,
    value,
    onChange,
    urlError,
    entityType,
    entityId,
    property,
    nestedId,
}) => {
    //const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const handleOpenModal = () => setOpen(true);
    const handleCloseModal = () => setOpen(false);

    return (
        <>
            <TextField
                label={label}
                fullWidth
                margin="normal"
                value={value}
                onChange={onChange}
                error={!!urlError}

                helperText={urlError}

                slotProps={{
                    input: {
                        endAdornment: (
                            <IconButton
                                onClick={handleOpenModal}
                                size="small"
                                sx={{
                                    border: `1px solid ${theme.palette.primary.main}`,
                                    borderRadius: '6px',
                                    padding: '4px',
                                    ml: 1,
                                }}
                            >
                                <TranslateIcon colorHex={theme.palette.primary.main} />
                            </IconButton>
                        ),
                    },
                }}
            />
            <TranslationEditModal
                open={open}
                onClose={handleCloseModal}
                entityType={entityType}
                entityId={entityId}
                property={property}
                nestedId={nestedId}
            />
        </>
    );
};

export default TranslatableUrl;
